import React from 'react';
import styles from './_style.module.scss';
import OptionsCommon from 'components/quote_builder_widget/form/options/OptionsCommon.jsx';

const OptionBoolean = ({ id, drawing, option, unit }) => {
  const formattedValue = (value) => value;

  const [isVisible, value, onChange, highlighted] = OptionsCommon({
    formattedValue,
    id,
    drawing,
    option,
    unit,
  });

  if (!isVisible) {
    return <input type="hidden" name={option.name} value={value} />;
  }

  return (
    <div className={styles.formGroup} data-widget-element="form-group">
      <label className={styles.label} data-widget-element="label">{option.presented_name}</label>
      <div className={styles.inputWrapper} data-widget-element="input-wrapper">
        <input
          name={"__" + option.name}
          type="checkbox"
          className={styles.checkbox}
          value="1"
          onChange={onChange}
          checked={value == 1}
          autoComplete="off"
          readOnly={option.readonly_option}
          data-widget-element="checkbox"
        />
        <input type="hidden" name={option.name} value={value} />
      </div>
    </div>
  );
};

export default OptionBoolean;
